import React from 'react';
import { Download, FileText } from 'lucide-react';
import { useApp } from './AppContext';
import { useTranslation } from '../i18n/TranslationContext';

export function ContractDownloadRequired() {
  const { downloadContract } = useApp();
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-2xl p-6 shadow-[0_4px_16px_rgba(0,0,0,0.08)] mb-6">
      <div className="flex items-center mb-4">
        <div className="w-8 h-8 bg-[var(--ucm-light-orange)] rounded-full flex items-center justify-center mr-3">
          <FileText size={16} className="text-[var(--ucm-dark-orange)]" />
        </div>
        <h3 className="font-semibold text-[var(--ucm-text-dark)]">{t('contractStatus.contractProcess')}</h3>
      </div>

      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-[var(--ucm-text-medium)]">{t('contractStatus.status')}</span>
          <span className="text-sm font-semibold text-[var(--ucm-warning-orange)]">{t('contractStatus.downloadRequired.status')}</span>
        </div>
        <p className="text-sm text-[var(--ucm-text-medium)] mb-3">
          {t('contractStatus.downloadRequired.description')}
        </p>
        
        <div className="text-xs text-[var(--ucm-text-light)] mb-4">
          {t('contractStatus.stepOf', { current: 4, total: 8 })}
        </div>
      </div>

      <button
        onClick={downloadContract}
        className="w-full h-12 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200 flex items-center justify-center"
      >
        <Download size={16} className="mr-2" />
        {t('contractStatus.downloadRequired.downloadContract')}
      </button>
    </div>
  );
}